/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Layout } from 'react-grid-layout';
import { VisualizationType } from './VisualizationType';

export const getVisualizationLayoutDefault = (id: string, type: string): Layout => {
  switch (type) {
    case VisualizationType.RaceOrderTable:
      return { i: id, x: 0, y: Infinity, w: 6, h: 30 };
    case VisualizationType.PitStrategyTable:
    case VisualizationType.PitRoadSummaryTable:
    case VisualizationType.PitRoadDurationTable:
    case VisualizationType.PitRoadDurationGraph:
    case VisualizationType.PitRoadCrewAnalysisGraph:
    case VisualizationType.PitRoadCrewTable:
    case VisualizationType.PitRoadCycleTimeTable:
    case VisualizationType.PitRoadCycleTimeGraph:
    case VisualizationType.RankAnalysisTable:
      return { i: id, x: 0, y: Infinity, w: 12, h: 30 };
    case VisualizationType.Weather:
    case VisualizationType.WindyWeather:
    case VisualizationType.WeatherMap:
      return { i: id, x: 0, y: Infinity, w: 6, h: 20 };
    case VisualizationType.FastestLapsTable:
      return { i: id, x: 0, y: Infinity, w: 12, h: 30 };
    case VisualizationType.RankAnalysisReport:
      return { i: id, x: 0, y: Infinity, w: 12, h: 30 };
    case VisualizationType.SessionInfo:
    case VisualizationType.AudioTranscription:
    case VisualizationType.BobPockrassTwitterFeed:
    case VisualizationType.VehicleAudioActivityLevel:
    case VisualizationType.VehicleGPSQuality:
    case VisualizationType.CompetitorGroupsDock:
      return { i: id, x: 0, y: Infinity, w: 3, h: 20 };
    case VisualizationType.AlertNotificationLog:
      return { i: id, x: 0, y: Infinity, w: 6, h: 40 };
    case VisualizationType.TrackTemperature:
      return { i: id, w: 12, x: 0, y: 0, h: 50 };
    case VisualizationType.ManufacturerPoints:
      return { i: id, x: 0, y: Infinity, w: 2, h: 11 };
    case VisualizationType.LapDeltaTable:
      return { i: id, x: 0, y: Infinity, w: 4, h: 12 };
    default:
      return { i: id, x: 0, y: Infinity, w: 6, h: 20 };
  }
};
